import template_03 from "../../assets/image/template_03.png";

const NotFound = () => {
  return (
    <>
      <div className="w-full h-screen" dir="ltr">
        <img src={template_03} alt="not fount" className="w-full h-full" />
      </div>
    </>
  );
};

export default NotFound;
